<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" class="text-right">
							{{ currentdate | formatDateTime }}
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="parameters.length">
					<div class="text-subtitle-1 font-weight-bold">Параметри</div>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr v-for="(item, index) in parameters" :key="index">
									<td width="50%">{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<div class="mx-8 my-6">
					<v-divider></v-divider>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left">Валюта</th>
									<th class="text-left">Мінімальна</th>
									<th class="text-left">Середня</th>
									<th class="text-left">Максимальна</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>UAH</td>
									<td>{{ data.minPriceUAH | toMoney }}</td>
									<td class="font-weight-bold text-subtitle-2">{{ data.avgPriceUAH | toMoney }}</td>
									<td>{{ data.maxPriceUAH | toMoney }}</td>
								</tr>
								<tr>
									<td>USD</td>
									<td>{{ data.minPriceUSD | toMoney }}</td>
									<td class="font-weight-bold text-subtitle-2">{{ data.avgPriceUSD | toMoney }}</td>
									<td>{{ data.maxPriceUSD | toMoney }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },

	computed: {
		parameters() {
			return [
				{ code: 'category', name: 'Категорія', description: '', type: 'string', value: this.params?.category?.name },
				{ code: 'brand', name: 'Марка', description: '', type: 'string', value: this.params?.brand?.name },
				{ code: 'model', name: 'Модель', description: '', type: 'string', value: this.params?.model?.name },
				{ code: 'yearProd', name: 'Рік випуску авто', description: '', type: 'string', value: this.params?.yearProd },
				{ code: 'type', name: "Категорія за об'ємом двигуна", description:  this.params?.type?.description, type: 'string', value: this.params?.type?.name + ' (' + this.params?.type?.description+')' },
			]
		},


		/* parameters() {
			return [
				{ code: 'organization', name: 'Організація', description: '', type: 'string', value: this.params?.organization?.name },
			]
		}, */

		/* equipments() {
			return this.data?.Results ? this.data.Results : [];
		}, */
	},
}

</script>